import axios from "axios";
import Links from "../constants/Links";

/**
 * Passkey (WebAuthn) API hooks.
 * Paths resolve against the global axios baseURL which already ends in /api.
 */
const Passkey = {
  // Enrollment (logged in) -----------------------------------------------
  requestVerification: async () => axios.post(Links.passkey.requestVerification),
  verifyCode: async (code) => axios.post(Links.passkey.verifyCode, { code }),
  // body: { challengeHandle, credential, deviceName }
  register: async (body) => axios.post(Links.passkey.register, body),

  // Direct sign-in (public, usernameless) --------------------------------
  signInStart: async () => axios.post(Links.passkey.signInStart),
  // body: { challengeHandle, credential }
  signInFinish: async (body) => axios.post(Links.passkey.signInFinish, body),

  // Step-up (logged in) — prove possession without issuing a new session.
  verifyStart: async () => axios.post(Links.passkey.verifyStart),
  // body: { challengeHandle, credential }
  verifyFinish: async (body) => axios.post(Links.passkey.verifyFinish, body),

  // Credential management (logged in) ------------------------------------
  listCredentials: async () => axios.get(Links.passkey.credentials),
  renameCredential: async (id, deviceName) =>
    axios.patch(`${Links.passkey.credentials}/${id}`, { deviceName }),
  deleteCredential: async (id) =>
    axios.delete(`${Links.passkey.credentials}/${id}`),
};

export default Passkey;
